<div class="qty-selector-wrapper">
    <div class="qty-btn" (click)="DecrementQuantity()">-</div>
    <span class="qty-wrapper">{{ Quantity }}</span>
    <div class="qty-btn" (click)="IncrementQuantity()">+</div>
</div>